import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessagesComponent } from './messages.component';
import { MessagesRoutingModule } from './messages-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import { MessagesModule } from "../../component/ing/messages/messages";
import { MessageModule } from "../../component/ing/message/message";
import { TableModule } from "../../component/ing/table/table";
import {ButtonModule} from "../../component/ing/button/button";
import {InputTextModule} from "../../component/ing/inputtext/inputtext";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MessagesRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    TableModule,
    ButtonModule,
    MessageModule,
    InputTextModule,
    MessagesModule
  ],
  declarations: [MessagesComponent]
})
export class MessagesDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/messages/messagesDemo.module.ts